import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SharedService } from 'src/app/services/shared.service';
import { CommonService } from '../common.service';

@Component({
  selector: 'app-physician-details',
  templateUrl: './physician-details.component.html',
  styleUrls: ['./physician-details.component.scss']
})
export class PhysicianDetailsComponent implements OnInit {
  physicianInfo: any = {};
  clientInfo: any = {};

  constructor(
    private dialogRef: MatDialogRef<PhysicianDetailsComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private commonService: CommonService,
    public sharedService: SharedService,
  ) { }

  ngOnInit(): void {
    // console.log(this.data);
    this.getPhysician();
  }

  getPhysician() {
    this.commonService.getLabClient(this.data.physicianId).subscribe(res => {
      if (res) {
        this.physicianInfo = res;
        this.getLabClient(this.physicianInfo.clientId);
      } else {
        if (this.data && this.data.labClientId) {
          this.getLabClient(this.data.labClientId);
        }
      }
    });
  }

  getLabClient(labClientId) {
    this.commonService.getLabClient(labClientId).subscribe(res => {
      if (res) {
        this.clientInfo = res;
      }
    });
  }

  cancelClick(): void {
    this.dialogRef.close();
  }

}
